import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
//import Datetime from 'react-datetime';

import { StyledModal, StyledBody, StyledHeader } from '../AddWellnessInitiative/styles';
// import { imgPath } from '../../utils/constants';
import { SubmitButton, Error, SubmitContainer ,PasswordContent } from '../ForgetPassword/styles';
import { ErrorMessage } from '../LoginPage/styles';
import { SingleTile, SettingsName, StyledInput } from '../../containers/Settings/styles';
//import { InputContainer, DateIconContainer } from '../CreateEvent/styles';
//import { DateIcon } from '../SvgComponents';

import { resetPassword } from '../../redux/actions';
import { Eyecloseicon, Eyeicon, RecognitionCloseIcon } from '../../utils/icons';

// import {LOGO_URL} from '../../utils/config';
class ResetPasswordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      rePassword: '',
      showErrmsg: false,
      errMsg: '',
      passMsg: false,
      checkMail: false,
      dateOfBirth: false,
      birthDate: '',
      showDate: '',
      showPassword: false,
      showConfirmPassword: false,
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  handleClick = (e) => {
    if(this.datePickerWrapper && !this.datePickerWrapper.contains(e.target)) {
      this.setState({
        showDate: ''
      });
    }
  };

  setDatePickerWrapper = (node) =>  {
    this.datePickerWrapper = node;
  };
  
  navigateLink = () => {
    const { history } = this.props;
    history.push('/user');
  };

  handleClose = () => {
    this.navigateLink();
  };

  validatePassword = (e) => {
    e.preventDefault();
    const { pathname } = this.props.history.location;
    let resetPasswordUrl = pathname.split('/');
    let obj={};
    obj['link_time'] = resetPasswordUrl[4];
    let token = '';
    if(resetPasswordUrl[resetPasswordUrl.length - 1] === '') {
      for( let i=5; i<=resetPasswordUrl.length-3; i++) {
        if(i === resetPasswordUrl.length -3) {
          token = token+resetPasswordUrl[i]
        }
        else {
          token = token+resetPasswordUrl[i]+'/'
        }
      }
    }
    else {
      for( let i=5; i<=resetPasswordUrl.length-2; i++) {
        if(i === resetPasswordUrl.length -2) {
          token = token+resetPasswordUrl[i]
        }
        else {
          token = token+resetPasswordUrl[i]+'/'
        }
      }
    }
    obj['remember_token'] = token;
    obj['password'] = this.state.password.trim();
    //obj['birthday'] = this.state.birthDate;
    const { resetPassword } = this.props;
    resetPassword(obj);
    this.setState({
      showErrmsg: false,
      errMsg: '',
      checkMail: false
    })
    this.navigateLink();
  };

  inputChangePass = (e) => {
    const regex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})');
    if(e.target.name === 'password') {
      this.setState({
        'password':e.target.value,
        showErrmsg: false,
        errMsg: '',
        passMsg: false
      },() => {
        if(!regex.test(this.state.password)) {
          this.setState({
            passMsg: true,
            checkMail: false
          })
        } else if(this.state.rePassword && (this.state.password !== this.state.rePassword)) {
          this.setState({
            showErrmsg: true,
            errMsg: 'New password and Confirm password should match',
            checkMail: false
          })
        }
        else {
          this.setState({
            checkMail: true
          })
        }
      })
    }
    else {
      this.setState({
        'rePassword': e.target.value,
        showErrmsg: true,
        errMsg: 'New password and Confirm password should match'
      },() => {
        if(this.state.password === this.state.rePassword) {
          if(regex.test(this.state.rePassword)) {
            this.setState({
              checkMail: true,
              showErrmsg: false,
              errMsg: ''
            })
          }
          else {
            this.setState({
              checkMail: false,
              showErrmsg: false,
              passMsg: true
            })
          }
        }
        else {
          this.setState({
            checkMail: false,
            showErrmsg: true,
            errMsg: 'New password and Confirm password should match'
          })
        }
      })
    }
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword
    }));
  };

  toggleConfirmPasswordVisibility = () => {
    this.setState((prevState) => ({
      showConfirmPassword: !prevState.showConfirmPassword
    }));
  };

  closeDate = (e) => {
    if(e.target.className === 'form-control') {
      if(this.state.count>0 && e.target.className === 'form-control' && this.state.showDate=='birthDate') {
        this.setState({ showDate: '' })
      }
      else {
        this.setState({  count: 1 })
      }
    }
  }

  showDatePicker = (value) => {
    if(this.state.showDate === value) {
      this.setState({
        showDate: ''
      });
    } else {
      this.setState({
        showDate: value
      });
    }
  };

  changeDate = (e, stateName) => {
    let value = moment();
    value = moment(e._d).format('YYYY-MM-DD');
    this.setState({
      [stateName]: value,
      showDate: '',
      dateOfBirth: true
    });
  };

  render() {
    const { checkMail, passMsg, password, rePassword, showErrmsg, errMsg, showPassword, showConfirmPassword } = this.state;
    // const yesterday = Datetime.moment().subtract(18, 'years');
    // const valid = (currentDate) => currentDate.isBefore(yesterday);
    return(
      <StyledModal  show={true} onHide={() => this.navigateLink()} >
        <StyledBody style={{ padding: '16px 24px' }}>
          <PasswordContent >
            <StyledHeader closeButton={false}>
              <p className='requestText'>Request New Password</p>
              <div className='closeHover' onClick={this.handleClose}>{RecognitionCloseIcon()}</div> 
            </StyledHeader>
          </PasswordContent>
      
          <form onSubmit={(e) => this.validatePassword(e)}>
                    
            <SingleTile width="100">
              <SettingsName>
                New Passwords 
              </SettingsName>
              <div style={{ position: 'relative' }}>
                <StyledInput 
                  type={showPassword ? "text" : "password"} 
                  placeholder="Enter new password" 
                  name="password" 
                  value={password} 
                  onChange={(e) => this.inputChangePass(e)}
                  style={{ paddingRight: '40px' , placeholder:'#BDBDBD'}}
                />
                <div 
                  onClick={this.togglePasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: '12px',
                    top: '73%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '18px',
                    color: '#DA6C74',
                    userSelect: 'none'
                  }}
                >
                  {showPassword ? <span>{Eyecloseicon('#DA6C74')}</span> : <span>{Eyeicon('#DA6C74')}</span>}
                </div>
              </div>
            </SingleTile>
            { passMsg 
              &&
              <Error>
                <ErrorMessage>Must be at least 8 characters and contain one uppercase, lowercase, and number</ErrorMessage> 
              </Error>
            } 
            <SingleTile width="100">
              <SettingsName>
                Confirm Password
              </SettingsName>
              <div style={{ position: 'relative' }}>
                <StyledInput 
                  type={showConfirmPassword ? "text" : "password"} 
                  placeholder="Confirm new password" 
                  name="rePassword" 
                  value={rePassword} 
                  onChange={(e) => this.inputChangePass(e)}
                  style={{ paddingRight: '40px', placeholder:'#BDBDBD' }}
                />
                <div 
                  onClick={this.toggleConfirmPasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: '12px',
                    top: '73%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '18px',
                    color: '#F37A65',
                    userSelect: 'none'
                  }}
                >
                  {showConfirmPassword ? <span>{Eyecloseicon('#DA6C74')}</span> : <span>{Eyeicon('#DA6C74')}</span>}
                </div>
              </div>
            </SingleTile> 
            { showErrmsg 
              &&
              <Error>
                <ErrorMessage>{errMsg}</ErrorMessage> 
              </Error>
            }   
            <SubmitContainer>
              <SubmitButton 
                className='SubmitBtn'
                type="submit"
                float={1} 
                Align={1}  
                width= "200px" 
                height="40px"
                radius="4px" 
                fontSize="16px"
                disabled={!checkMail || rePassword == '' || password == '' }
              >
                Submit
              </SubmitButton>  
            </SubmitContainer>
          </form>
        </StyledBody>
      </StyledModal>
    );
  }
}

ResetPasswordModal.propTypes = {
  resetPassword: PropTypes.func,
  history: PropTypes.object
};

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (data) => dispatch(resetPassword(data))
});

export default connect(null, mapDispatchToProps)(ResetPasswordModal);